import MessageDashboardContainer from './MessageDashboardContainer';
export default MessageDashboardContainer;
